import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import get from 'lodash/get';
import { Checkbox } from '@quintype/em/components/checkbox';
import { FieldLabel } from '@quintype/em/components/field-label';
import styles from './story-demarcation.module.css';
import { photoStoryIconsData } from './icons';
import { storyDemarcationStyle } from '../../actions/builder-action';

export function PhotoStoryDemarcation() {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const dispatch = useDispatch();
  const demarcationType = 'photoDemarcationIcon';

  const { enablePhotoDemarcationIcon, iconColor = '', darkIconColor = '' } = useSelector((state: any) =>
    get(state, ['builder', 'config', 'general', 'rows', 'photoDemarcationIcon'], {})
  );

  const updateIconHandler = (name: string, index: number) => {
    setSelectedIndex(index);
    dispatch(storyDemarcationStyle({ demarcationType, iconStyle: name }));
  };

  return (
    <>
      <div className={styles.checkBoxWrapper} data-test-id="photo-story-demarcation-checkbox">
        <Checkbox
          label="Photo Story Demarcation"
          id="photo-story-demarcation-Icon"
          checked={enablePhotoDemarcationIcon}
          onChange={(value: any) =>
            dispatch(storyDemarcationStyle({ demarcationType, enablePhotoDemarcationIcon: value }))
          }
        />
      </div>
      <FieldLabel label="Choose Icon style" />
      <div className={styles.iconWrapper}>
        {photoStoryIconsData.map((item: { name: string; svg: string }, index: number) => (
          <div
            onClick={() => updateIconHandler(item.name, index)}
            className={selectedIndex === index ? styles.selectedImgWrapper : styles.imageWrapper}
            data-test-id={item.name}
            key={`photo-icon-${item.name}`}
          >
            <img src={item.svg} className={styles.image} alt="Photo Story Demarcation Icon style" />
          </div>
        ))}
      </div>
    </>
  );
}
